export const TIPOS = {
  venta:         { label:'Venta',          icon:'ti-file-invoice',          color:'#10b981', bg:'rgba(16,185,129,0.12)',  border:'rgba(16,185,129,0.3)'  },
  compra:        { label:'Compra / Egreso',icon:'ti-shopping-cart',          color:'#ef4444', bg:'rgba(239,68,68,0.12)',   border:'rgba(239,68,68,0.3)'   },
  gasto_fijo:    { label:'Gasto Fijo',     icon:'ti-receipt',                color:'#8b5cf6', bg:'rgba(139,92,246,0.12)', border:'rgba(139,92,246,0.3)'  },
  gasto_variable:{ label:'Gasto Variable', icon:'ti-wave-sine',              color:'#f59e0b', bg:'rgba(245,158,11,0.12)', border:'rgba(245,158,11,0.3)'  },
  sueldo:        { label:'Sueldo',         icon:'ti-users',                  color:'#ec4899', bg:'rgba(236,72,153,0.12)', border:'rgba(236,72,153,0.3)'  },
  iva:           { label:'IVA',            icon:'ti-percentage',             color:'#3b82f6', bg:'rgba(59,130,246,0.12)', border:'rgba(59,130,246,0.3)'  },
  otro:          { label:'Otro',           icon:'ti-dots-circle-horizontal', color:'#6b7280', bg:'rgba(107,114,128,0.12)',border:'rgba(107,114,128,0.3)' },
};

export const SUB_LABELS = {
  facturada:'Facturada', sin_factura:'Sin Factura (S/F)',
  nacional:'Nacional', importacion:'Importación directa',
  tvh:'Importación TVH', courrier:'Courrier / Aduana',
};

export const CATS = {
  venta:         ['Ventas de productos','Ventas de servicios','Otros ingresos','Anticipo clientes','Devoluciones recibidas'],
  compra:        ['Materiales e insumos','Importaciones','Pago courier / despacho','Repuestos','Otros egresos'],
  gasto_fijo:    ['Arriendo / renta','Internet y telefonía','Electricidad','Contabilidad / honorarios','Software / suscripciones','Seguros fijos'],
  gasto_variable:['Transporte / flete','Publicidad y marketing','Combustible','Reparaciones','Embalaje','Otros variables'],
  sueldo:        ['Sueldo base','Horas extra','Bonos','Gratificación','Finiquito','AFP','Isapre / Fonasa'],
  iva:           ['IVA ventas (débito fiscal)','IVA compras (crédito fiscal)','Pago IVA al SII','Devolución IVA'],
  otro:          ['Multas','Ajustes contables','Depreciación','Préstamos','Otros'],
};

export const fmt = (n) =>
  new Intl.NumberFormat('es-CL',{style:'currency',currency:'CLP',maximumFractionDigits:0}).format(n||0);

export const fmtDate = (d) =>
  d ? new Date(d+'T12:00:00').toLocaleDateString('es-CL') : '-';

export const today = () => new Date().toISOString().split('T')[0];

export const EMPTY_FORM = {
  tipo:'venta', subTipo:'facturada', categoria:'Ventas de productos',
  descripcion:'', monto:'', monto_iva:'', monto_total:'',
  fecha:today(), notas:'',
  rutContraparte:'', razonSocial:'', nFactura:'', pn:'', clienteFinal:'',
  tipoDoc:'FAC',
};

export const MES_LABEL = (ym) => {
  if (!ym) return '';
  const [y,m] = ym.split('-');
  const N = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
  return `${N[parseInt(m,10)-1]}-${y.slice(2)}`;
};

export const esVenta  = (m) => m.tipo === 'venta';
export const esCompra = (m) => ['compra','gasto_fijo','gasto_variable','sueldo'].includes(m.tipo);
